import { INVREL_ARE_LOADING, INVREL_FETCH_DATA_SUCCESS, INVREL_HAVE_ERROR } from '../actionType';
// import { CONTACTUS_ARE_LOADING, CONTACTUS_FETCH_DATA_SUCCESS, CONTACTUS_HAVE_ERROR } from '../actionType';

const initialState = {
    data: [],
    loading: true,
    error: []
  };
  
  export function InvRelReducer(state = initialState, action) {
    switch (action.type) {
        case INVREL_HAVE_ERROR:
            return {
                ...state,
                error:action.hasError,
                loading:false,
            }
    
        case INVREL_ARE_LOADING:
           return {
            ...state,
            loading:action.isLoading
        }
    
        case INVREL_FETCH_DATA_SUCCESS:
            return {
                ...state,
                data:action.InvRel,
                loading:false,
            }

        default:
            return state;
    }
}
